import { render, staticRenderFns } from "./ApprovedConsumBatches.vue?vue&type=template&id=6aeb9098&scoped=true"
import script from "./ApprovedConsumBatches.vue?vue&type=script&lang=js"
export * from "./ApprovedConsumBatches.vue?vue&type=script&lang=js"
import style0 from "./ApprovedConsumBatches.vue?vue&type=style&index=0&id=6aeb9098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeb9098",
  null
  
)

export default component.exports